import { defineMessages } from 'react-intl';

const messages = defineMessages({
  transmissionDateLabel: {
    id: 'App.RentForecast.Transmission.Date.Label',
    defaultMessage: 'Transmission Date',
  },
  transmissionNumberLabel: {
    id: 'App.RentForecast.Transmission.Number.Label',
    defaultMessage: 'Transmission Number',
  },
});

export default messages;
